import React, { useEffect, useRef } from 'react';
import mainSymbol from '../assets/img/main-symbol.png';

const Intro = () => {
  // Create refs for the elements
  const mainSymbolRef = useRef(null);
  const mainLogoRef = useRef(null);
  const mainLocationRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;

      if (scrollPercent < 18) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            mainSymbolRef.current.classList.add('ani');
            mainLogoRef.current.classList.add('ani');
            mainLocationRef.current.classList.add('ani');
          });
        }, 400);
      } else {
        requestAnimationFrame(() => {
          mainSymbolRef.current.classList.remove('ani');
          mainLogoRef.current.classList.remove('ani');
          mainLocationRef.current.classList.remove('ani');
        });
      }

      if (scrollPercent > 20) {
        requestAnimationFrame(() => {
          mainSymbolRef.current.classList.add('hide');
          mainLogoRef.current.classList.add('hide');
          mainLocationRef.current.classList.add('hide');
        });
      }
    };

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          mainSymbolRef.current.classList.add('ani');
          mainLogoRef.current.classList.add('ani');
          mainLocationRef.current.classList.add('ani');
        }
      }
    });

    window.addEventListener('scroll', handleScroll);
    const introSection = document.querySelector('.intro__inner');
    if (introSection) observer.observe(introSection);

    // 페이지 로드 시 스크롤 위치를 최상단으로 강제 이동
    window.scrollTo(0, 0);
    setTimeout(() => {
      requestAnimationFrame(() => {
        mainSymbolRef.current.classList.add('ani');
        mainLogoRef.current.classList.add('ani');
        mainLocationRef.current.classList.add('ani');
      });
    }, 200);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section id="intro" data-section="intro">
      <div className="intro__inner">
        <img
          alt="MOSU Symbol"
          src={mainSymbol}
          className="main-intro-symbol"
          ref={mainSymbolRef}
        />
        <div className={'txt-logo-mosu'} ref={mainLogoRef}>
          MOSU
        </div>
        <div className={'txt-logo-location'} ref={mainLocationRef}>
          SEOUL
        </div>
      </div>
    </section>
  );
};

export default Intro;
